import React, { useState } from 'react'
import { Col, Row } from 'antd'
import './styles.css'
import PdfMaker from '../../3dResume/components/PdfMaker/PdfMaker'

const UserCredentials = ({ data, error, setError }) => {

  const [imagesGenrated, setImagesGenerated] = useState(false);


  return (
    <div className='credentialing-main'>
      <Col>
        <div className='credentials-bold-text'>
          {`Uploaded documents (${data?.TalentDocuments?.length}/83)`}
        </div>
        <div className='credentials-bold-text'>
          Download a PDF package of credentials
        </div>
        <div className='credentials-light-text'>
          Download and generate a package of the candidate’s materials. Drag documents to rearrange the order of
          the credentials to create your PDF package.
        </div>
        {data?.TalentDocuments?.length > 0 ? (
          <PdfMaker
            data={data.TalentDocuments}
            imagesGenrated={imagesGenrated}
            setImagesGenerated={setImagesGenerated}
            error={error}
            setError={setError}
          />
        )
          : (
            <div style={{ marginTop: '2%' }}>
              <div className="resume-3d-card-box">
                <p className="noData-Text">NO DATA</p>
              </div>
            </div>
          )}
      </Col>
    </div>
  )
}
export default UserCredentials